import React, { useRef } from "react";
import { Card, Button } from "antd";
import MaterialForm from "./MaterialForm";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { useModelDispatchers } from "../../../models";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const { closeNav } = useModelDispatchers("nav");
    const formRef = useRef();
    const onSave = () => {
        formRef.current.insert();
    }
    const onReset = () => {
        formRef.current.reset();
    }
    const onClose = () => {
        closeNav();
    }
   
    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">新增配件</span>
                </h3>
                <div style={{ width: "500px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.DATA_M_AD_SAVE}>
                        <Button type="primary" onClick={onSave}>保存</Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onReset}>重置</Button>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <MaterialForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT} />
        </Card>
    )
};